var map = {
	"./Case_Havelaar_480x1080_BananaDay_01.mp4": 78481,
	"./Case_Havelaar_480x1080_BananaDay_02.mp4": 66142,
	"./Case_Havelaar_480x1080_BananaDay_03.mp4": 54595,
	"./Case_Havelaar_480x1080_BananaDay_04.mp4": 21864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57146;